<template>
  <div class="settings-icon-wrapper" title="Настроить таблицу" @click="emitOpenModal">
    <UiBaseIcon width="20px" height="20px" color="#232323" icon-name="cog" />
  </div>
</template>

<script>
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

export default {
  components: { UiBaseIcon },
  methods: {
    emitOpenModal() {
      this.$emit('update:show', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.settings-icon-wrapper {
  padding: rem(5px);
  margin: 10px 0 0 0;
  background: $white;
  border: 1px solid #eee;

  @include unselectable();
  @include border_radius(5px);
  @include createFlex(flexbox, nowrap, row, center, center, center);

  &:hover {
    cursor: pointer;

    path {
      fill: $primary;
    }
  }

  &:active {
    background: darken($white, 1%);
  }
}
</style>
